export const headCellDistribution = [
  { id: "option", disablePadding: false, label: "" },
  { id: "category", disablePadding: false, label: "Categoría" },
  { id: "product", disablePadding: false, label: "Producto" },
  { id: "imeiCode", disablePadding: false, label: "Código IMEI" },
  { id: "personDeliver", disablePadding: false, label: "Persona que envía" },
  { id: "user", disablePadding: false, label: "Persona que recibe" },
  { id: "emailSeller", disablePadding: false, label: "Email vendedor" },
  { id: "status", disablePadding: false, label: "Estatus" },
  { id: "destinySite", disablePadding: false, label: "Sucursal destino" },
  { id: "date", disablePadding: false, label: "Ult actualización" },
];
